import script from "./allDirectorsOrActor.vue?vue&type=script&lang=ts&setup=true"
export * from "./allDirectorsOrActor.vue?vue&type=script&lang=ts&setup=true"

import "./allDirectorsOrActor.vue?vue&type=style&index=0&id=37fe8689&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37fe8689"]])

export default __exports__